// ===== VALIDAÇÃO CENTRALIZADA =====
// Uso: if(!validarFormulario([{id:'p-cliente',label:'Cliente'},{id:'p-valor',label:'Valor',tipo:'numero_positivo'}]))return;
// Campos inválidos recebem borda vermelha + shake e o toast lista o que falta.
function validarFormulario(regras){
  const erros=[];
  regras.forEach(({id,label,tipo='texto',min})=>{
    const el=document.getElementById(id);
    if(!el)return;
    const val=el.value?.trim?.()??el.value;
    let invalido=false;
    switch(tipo){
      case 'texto':        invalido=!val; break;
      case 'numero_positivo': invalido=!(parseFloat(val)>0); break;
      case 'numero':       invalido=isNaN(parseFloat(val)); break;
      case 'select':       invalido=!val||val===''; break;
      case 'data':         invalido=!val||!/^\d{4}-\d{2}-\d{2}$/.test(val); break;
      case 'min':          invalido=!(parseFloat(val)>=(min||0)); break;
    }
    if(invalido){
      erros.push(label);
      el.classList.add('campo-invalido');
      const limpar=()=>{el.classList.remove('campo-invalido');el.removeEventListener('input',limpar);el.removeEventListener('change',limpar)};
      el.addEventListener('input',limpar);
      el.addEventListener('change',limpar);
      el.focus?.();
    }
  });
  if(erros.length){
    const msg=erros.length===1?`Preencha: ${erros[0]}.`:`Preencha: ${erros.slice(0,-1).join(', ')} e ${erros[erros.length-1]}.`;
    toast(msg,'error');
    return false;
  }
  return true;
}

